import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show after 33 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 33 * 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className={`fixed bottom-0 left-0 w-full bg-[#FAFAF7] p-4 border-t border-[#E5E5E0] z-[9999] flex items-center justify-between transition-transform duration-500 md:hidden ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} id="sticky-cta" data-id="element-275">
      <div className="text-left flex-1" data-id="element-276">
        <div className="text-[10px] uppercase text-[#666] font-bold font-sans tracking-wider" data-id="element-277">
          The Knee Geometry Method
        </div>
        <div className="text-[14px] font-bold text-[#1a1a1a] font-sans" data-id="element-278">
          $6.99{' '}
          <span className="text-[#888] font-normal line-through text-[12px]" data-id="element-279">
            $19.99
          </span>
        </div>
      </div>
      <a href="#get-the-method" className="bg-[#8B2500] text-white no-underline font-bold px-5 py-2 rounded-sm text-[12px] uppercase tracking-wide font-sans" data-id="element-280">
        Get the Guide
      </a>
    </div>;
}